// extracted by mini-css-extract-plugin
export default {"productGrid":"EZ-z","centerLink":"FZ-z","productSection":"GZ-z","item":"HZ-z","ctaButton":"IZ-z"};